export const loadGoogleMaps = () => {
    if (window.google || window._mapsLoaded) return;
    window._mapsLoaded = true;
  
    // ✅ Use CRA environment variable
    const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
  
    if (!apiKey) {
      console.error("❌ Google Maps API key missing. Check your .env file.");
      return;
    }
  
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places,marker&v=beta&loading=async`;
    script.async = true;
    document.head.appendChild(script);
  };